export default __webpack_public_path__ + "static/media/logo.b9c13a30.png";